"use strict";

// Project Home thread (app shell). Vanilla JS, no framework.
//
//   * Live thread: socket events fetch the server-rendered entry, so a card
//     looks the same live as on reload. Updated cards are replaced in place.
//   * Works for General and for a DM picked in the sidebar (?channel=<id>).
//
// The right panel, header counts, AJAX forms and task filters live in
// shell.js.

(function () {
  var root = document.querySelector('.thread[data-thread-mode="home"]');
  var base = root ? root.getAttribute('data-base') : null;

  if (!root) return;

  // A DM thread passes its channel to every fragment request.
  var dm = root.getAttribute('data-dm') === 'true';
  function chq(sep) { return dm ? sep + 'channel=' + encodeURIComponent(root.getAttribute('data-channel-id')) : ''; }

  // ── Live thread ───────────────────────────────────────────────────────────
  var stream = document.getElementById('chatStream');
  function atBottom() { return (stream.scrollHeight - stream.scrollTop - stream.clientHeight) < 80; }
  function insertHtml(html, replaceId) {
    var tpl = document.createElement('template');
    tpl.innerHTML = html.trim();
    var li = tpl.content.firstElementChild;
    if (!li) return;
    var empty = document.getElementById('threadEmpty');
    if (empty) empty.remove();
    var existing = replaceId ? document.getElementById(replaceId) : null;
    if (existing) { existing.replaceWith(li); return; }
    var stick = atBottom();
    stream.appendChild(li);
    if (stick) stream.scrollTop = stream.scrollHeight;
  }
  function fetchEntry(kind, id) {
    var url = kind === 'activity' ? base + '/thread/activity/' + id : base + '/thread/entries/' + id + chq('?');
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) { if (html) insertHtml(html, (kind === 'activity' ? 'a-' : 'm-') + id); });
  }
  function refreshStrip() { if (window.RushworksShell) window.RushworksShell.refresh(); }
  var channelId = parseInt(root.getAttribute('data-channel-id'), 10);
  window.addEventListener('rushworks:message-event', function (ev) {
    var p = ev.detail;
    if (!p || !p.message || p.message.channel_id !== channelId) {
      if (p && p.type === 'message_deleted' && p.channelId === channelId) {
        var gone = document.getElementById('m-' + p.messageId);
        if (gone) gone.remove();
      }
      return;
    }
    fetchEntry('message', p.message.id);
    if (p.message.kind && p.message.kind !== 'human') refreshStrip();
  });
  window.addEventListener('rushworks:activity-event', function (ev) {
    var e = ev.detail;
    if (!e || !e.id || dm) return;
    if (!document.getElementById('a-' + e.id)) fetchEntry('activity', e.id);
    refreshStrip();
  });
  window.addEventListener('rushworks:home-sent', function (ev) {
    if (ev.detail && ev.detail.id) fetchEntry('message', ev.detail.id).then(function () { stream.scrollTop = stream.scrollHeight; });
  });

  // Agent presence: "Ana is writing tasks for dev" (spec §6).
  var presenceEl = document.getElementById('threadPresence');
  window.addEventListener('rushworks:presence-event', function (ev) {
    if (!presenceEl || !ev.detail) return;
    var list = ev.detail.presence || [];
    presenceEl.innerHTML = '';
    list.forEach(function (p) {
      var item = document.createElement('span');
      item.className = 'thread__presence-item';
      var b = document.createElement('span');
      b.className = 'actor__badge'; b.setAttribute('aria-hidden', 'true'); b.textContent = 'AI';
      item.appendChild(b);
      item.appendChild(document.createTextNode(' ' + p.text));
      presenceEl.appendChild(item);
    });
    presenceEl.hidden = list.length === 0;
  });

  // Load earlier entries above, keeping the reader's place.
  var more = document.getElementById('threadMore');
  if (more) {
    more.addEventListener('click', function () {
      var before = stream.getAttribute('data-next-before');
      if (!before) return;
      more.disabled = true;
      fetch(base + '/thread?before=' + encodeURIComponent(before) + chq('&'), { credentials: 'same-origin' })
        .then(function (r) {
          var next = r.headers.get('X-Next-Before') || '';
          return r.text().then(function (html) { return { html: html, next: next }; });
        })
        .then(function (res) {
          var h0 = stream.scrollHeight;
          var anchor = more.parentNode;
          var tpl = document.createElement('template');
          tpl.innerHTML = res.html;
          var nodes = Array.prototype.slice.call(tpl.content.children).filter(function (n) { return !document.getElementById(n.id); });
          // Each insert goes directly after the anchor, so walk last-to-first
          // to leave the page in document order.
          nodes.slice().reverse().forEach(function (n) { anchor.parentNode.insertBefore(n, anchor.nextSibling); });
          if (res.next) { stream.setAttribute('data-next-before', res.next); more.disabled = false; }
          else { anchor.remove(); stream.removeAttribute('data-next-before'); }
          stream.scrollTop += stream.scrollHeight - h0;
        })
        .catch(function () { more.disabled = false; });
    });
  }
  // Open at the newest entry, unless a message anchor was requested.
  if (/^#m-\d+$/.test(location.hash)) {
    var target = document.getElementById(location.hash.slice(1));
    if (target) { target.scrollIntoView({ block: 'center' }); target.classList.add('chat__msg--flash'); }
  } else {
    stream.scrollTop = stream.scrollHeight;
  }
})();
